import { render, staticRenderFns } from "./bulk-invite.vue?vue&type=template&id=818d0456&"
import script from "./bulk-invite.vue?vue&type=script&lang=js&"
export * from "./bulk-invite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports